import type { CashInOutInsightsDTO } from "../models/cashInOutInsightsDto";
import type { CashInOutInsightsEntity } from "../../domain/entities/CashInOutInsightsEntity";

function mapSentiment(s: string): "positive" | "neutral" | "negative" {
  const t = (s ?? "").toLowerCase();
  if (t === "good") return "positive";
  if (t === "bad") return "negative";
  return "neutral";
}

export function cashInOutInsightsDtoToEntity(
  dto: CashInOutInsightsDTO,
): CashInOutInsightsEntity {
  const monthCountRaw = dto.month_count;
  const monthCount =
    typeof monthCountRaw === "number" && Number.isFinite(monthCountRaw)
      ? monthCountRaw
      : undefined;

  return {
    title: dto.title ?? "",
    body: dto.body ?? "",
    sentiment: mapSentiment(dto.sentiment ?? "neutral"),
    rangeLabel: dto.range_label?.trim() || undefined,
    monthCount,
    lastClosed: {
      monthLabel: dto.lastClosed?.monthLabel ?? "—",
      cashIn:
        dto.lastClosed?.cashIn === null || dto.lastClosed?.cashIn === undefined
          ? null
          : Number(dto.lastClosed.cashIn) || 0,
      cashOut:
        dto.lastClosed?.cashOut === null || dto.lastClosed?.cashOut === undefined
          ? null
          : Number(dto.lastClosed.cashOut) || 0,
      net:
        dto.lastClosed?.net === null || dto.lastClosed?.net === undefined
          ? null
          : Number(dto.lastClosed.net) || 0,
    },
  };
}

